
import { AppSection } from "@soenergy/frontend-library"
import pageMixin from "@/mixins/pageMixin"
import BlogPagination from "@/components/BlogPagination"

export default {
  components: {
    AppSection,
    BlogPagination
  },
  mixins: [pageMixin],
  async asyncData({ route, params, error, $storyblokHelper }) {
    const currentPage = route.name === "blog" ? 1 : parseInt(params.page)

    const perPage = 6

    const blogPage = await $storyblokHelper.get({
      id: "blog-page"
    })

    const paginatedPosts = await $storyblokHelper.get({
      starts_with: "blog/",
      is_startpage: false,
      sort_by: "content.date:desc",
      page: currentPage,
      per_page: perPage
    })

    const totalPosts = paginatedPosts.total

    const totalPages = Math.ceil(totalPosts / perPage)

    if (currentPage === 0 || !paginatedPosts.stories.length) {
      return error({ statusCode: 404, message: "No Posts found" })
    }

    return {
      posts: paginatedPosts.stories,
      totalPages,
      story: blogPage.story
    }
  },
  computed: {
    currentPage() {
      if (this.$nuxt.$route.name === "blog") {
        return 1
      }
      return parseInt(this.$nuxt.$route.params.page)
    },
    backgroundStyle() {
      return {
        backgroundColor: this.content.backgroundColor
      }
    },
    headingStyle() {
      return {
        color: this.content.headingColor
      }
    }
  },
  methods: {
    formatDate(date) {
      return this.$dayjs(date).format("DD/MM/YYYY")
    },
    getReadTime(block) {
      const wordsPerMinute = 200

      const renderedText = block
        .map(content =>
          content.textContent
            ? this.$storyapi.richTextResolver.render(content.textContent)
            : ""
        )
        .join(" ")

      let text = renderedText.replace(/<[^>]*>/g, " ")
      text = text.replace(/\s+/g, " ")
      text = text.trim()

      const wordCount = text.split(" ").length

      return Math.ceil(wordCount / wordsPerMinute)
    }
  }
}
